module.exports = __webpack_public_path__ + "static/media/pinOffbtn@2x.2ce85f8f.png";